import parseNumber from "@store/utilities/parseNumber";

const STATIC_PATH = "/userfiles/_static/store";

// -- Typography

const fallbackFont = "Arial, Helvetica, sans-serif";

export const TYPOGRAPHY = {
    fontFamily: {
        title: `'Lato', ${fallbackFont}`,
        base: `'Lato', ${fallbackFont}`,
        importUrl:
            "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;0,900;1,400;1,700;1,900&display=swap",
    },
    weight: {
        base: 400,
        bold: 700,
        black: 900,
    },
    size: {
        veryTiny: "10px",
        tiny: "12px",
        smallest: "13px",
        smaller: "14px",
        small: "15px",
        base: "16px",
        large: "18px",
        larger: "20px",
        largest: "24px",
    },
    lineHeight: {
        smaller: 1,
        small: 1.25,
        base: 1.5,
        large: 2,
    },
    spacing: {
        small: "0.5em",
        base: "1em",
        large: "1.5em",
        larger: "2em",
        largest: "3em",
    },
};

// -- Product

const productImageSizes = {
    small: {
        width: 311,
        height: 193,
    },
    medium: {
        width: 690,
        height: 429,
    },
    large: {
        width: 1164,
        height: 724,
    },
};

export const PRODUCT = {
    image: {
        ...productImageSizes,
        ratio: productImageSizes.large.height / productImageSizes.large.width,
    },
};

// -- Common

const contentWidth = 1410;
const spacing = {
    side: ["20px", "30px", "45px", "45px", "60px"],
    content: ["25px", "30px", "45px", "45px", "60px"],
    narrowContent: ["25px", "30px", "40px", "40px", "50px"],
};

const largestSideSpacing = spacing.side.filter(x => x).pop() as any;
const siteWidth = contentWidth + (parseNumber(largestSideSpacing) ?? 0) * 2;

export const COMMON = {
    breakpoints: [0, 600, 900, 1200, siteWidth],
    width: {
        content: contentWidth,
        site: siteWidth,
    },
    spacing,
    outline: {
        width: "2px",
        style: "solid",
    },
    defaultProductImagePath: `${STATIC_PATH}/product-not-available.svg`,
    defaultCategoryImagePath: `${STATIC_PATH}/category-not-available.svg`,
    defaultLargeCategoryImagePath: `${STATIC_PATH}/large-category-not-available.svg`,

};

// -- Menu

export const MENU = {
    mobileButtonSpacing: ".25em",
    topNavItemSpacing: ".8em",
};

// -- Form

export const FORM = {
    field: {
        padding: "1em",
        spacing: "1em",
    },
    button: {
        spacing: "1.6em",
    },
};
